import styled from 'styled-components'
import { ModalFooter } from './ModalPrimitives'

export const Dialog = styled.div`
   width: 520px;
   max-width: calc(100% - 40px);
   background: #FFFFFF;
   border-radius: 16px;
   box-shadow: 0 14px 16px -2px rgba(16, 24, 40, 0.06), 0 4px 6px -2px rgba(16, 24, 40, 0.04);
   display: flex;
   flex-direction: column;
   overflow: hidden;
`

export const Header = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 18px;

   h2 {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      color: #101018;
   }

   button {
      background: none;
      border: 0;
      font-size: 22px;
      cursor: pointer;
      line-height: 1;
      color: #3F3F45;
      padding: 6px;
   }
`

export const Body = styled.div`
   padding: 0 18px 18px 18px;
   color: #6D6D72;
   font-size: 14px;
   line-height: 24px;
`

export const Divider = styled.div`
   background: #F5F5F6;
   height: 1px;
`

export const Footer = styled(ModalFooter)`
   .primary {
      background: #AF7AD5;
      color: #FFFFFF;
      border: 0;
   }

   .primary:hover { background: #9b63c9; }
`